module.exports = __webpack_public_path__ + "img/3.eeb8f610.jpg";